import { Head, usePage } from '@inertiajs/react'
import { createElement } from 'react'

type InertiaMetaTag = {
  tagName: string
  headKey: string
  innerContent?: unknown
  httpEquiv?: string
  [attribute: string]: unknown
}

/**
 * Takes over server-managed metadata after hydration and on Inertia visits.
 * Rails renders the same `_inertia_meta` payload into the initial HTML.
 */
export function MetaTags() {
  const meta = (usePage().props._inertia_meta ?? []) as InertiaMetaTag[]

  return (
    <Head>
      {meta.map(({ tagName, headKey, innerContent, httpEquiv, ...attributes }) => {
        const content =
          innerContent == null
            ? null
            : typeof innerContent === 'string'
              ? innerContent
              : JSON.stringify(innerContent)

        return createElement(tagName, {
          key: headKey,
          'head-key': headKey,
          ...(httpEquiv ? { 'http-equiv': httpEquiv } : {}),
          ...attributes,
          ...(content != null ? { dangerouslySetInnerHTML: { __html: content } } : {}),
        })
      })}
    </Head>
  )
}
